export enum EndDateIndicationEnum {
    Immediately = 'End product immediately',
    WithFutureDate = 'End product with future date',
}
